/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import audioPage from './audioPage';
// import audioList from './audioList';
// import audioListBox from './audioListBox';
import list from './list';
import aplayIE11 from './aplayIE11';
import PublicMonitorCamera from './PublicMonitorCamera';
import PostSend from './PostSend';
// import PostMap from './PostMap';
// import postList from './postList';
// import PostDetail from './PostDetail';
// import PostRoadDetail from './PostRoadDetail';
import HavenList from './HavenList';
// import HavenDetail from './HavenDetail';
// import RadioDetail from './RadioDetail';
import Empty from './Empty';
// 新・公開画面
import ErrorPage from './PublicPage/ErrorPage';
import PublicMap from './PublicPage/Map';
import PublicList from './PublicPage/List';
import PublicDetail from './PublicPage/Detail';

// 以下はテスト用
import LineAdd from './Test/LineAdd';
import LineSend from './Test/LineSend';

import './css/basic.css';
import './css/layout.css';
import './css/App.css';

const App = () => (
  <BrowserRouter basename="/web">
    {/* <div> */}
    <Route exact path="/aplay/*/*" component={audioPage} />
    {/* <Route exact path="/audioList/*" component={audioList} /> */}
    {/* <Route exact path="/audioListBox/*" component={audioListBox} /> */}
    <Route exact path="/blist/*" component={list} />
    <Route exact path="/help/aplay_ie11" component={aplayIE11} />
    <Route exact path="/dcame/*/*" component={PublicMonitorCamera} />
    <Route exact path="/post/send/*" component={PostSend} />
    {/* <Route exact path="/post/map/*" component={PostMap} /> */}
    {/* <Route exact path="/post/list/*" component={postList} /> */}
    {/* <Route exact path="/post/Detail" component={PostDetail} /> */}
    {/* <Route exact path="/post/RoadDetail" component={PostRoadDetail} /> */}
    {/* <Route exact path="/post/HavenDetail" component={HavenDetail} /> */}
    {/* <Route exact path="/post/RadioDetail" component={RadioDetail} /> */}
    <Route exact path="/empty_page" component={Empty} />
    {/* 新・公開画面 */}
    <Route exact path="/ErrorPage" component={ErrorPage} />
    <Route exact path="/public/haven/*/*" component={HavenList} />
    <Route exact path="/public/map/*" component={PublicMap} />
    <Route exact path="/public/list/*" component={PublicList} />
    <Route exact path="/public/detail/*" component={PublicDetail} />
    {/* 以下はテスト用 */}
    <Route exact path="/qwfgsckq/LineAdd" component={LineAdd} />
    <Route exact path="/qwfgsckq/LineSend" component={LineSend} />
    {/* </div> */}
  </BrowserRouter>
);

export default App;
